export default __webpack_public_path__ + "static/media/parkeo1.ed4430b2.png";